export class DataCatalogPipelineSchedule {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "minIntervalSeconds",
            "baseName": "minIntervalSeconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "triggerOnSourceChange",
            "baseName": "triggerOnSourceChange",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPipelineSchedule.attributeTypeMap;
    }
    constructor() {
    }
}
